<!-- <mat-list *ngFor="let menu of menus">
  <mat-list-item routerLink="{{ menu.link }}" routerLinkActive="active" *ngIf="menu.show">
    <mat-icon> {{ menu.icon }}</mat-icon> {{ menu.name | translate }}
  </mat-list-item>
</mat-list> -->


<div *ngFor="let menu of menus">
  <mat-expansion-panel *ngIf="menu.show" hideToggle expandedHeight="0" class="left-nav-item mat-elevation-z0">
    <mat-expansion-panel-header style="padding-left: 0px !important;" expandedHeight="48px">
      <mat-nav-list disableRipple>
        <mat-list-item [routerLink]="[menu.link]" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <mat-icon style="margin: 0px !important;" mat-list-icon>{{ menu.icon }}</mat-icon>
          <h4 style="margin: 0px;">
            <span class="mat-small">
              {{ menu.name | translate }}
            </span>            
          </h4>
        </mat-list-item>
      </mat-nav-list>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</div>